export default "__VITE_ASSET__IOdJNQyD__"